import React from 'react';
import { Modal } from 'antd';
import { X } from '@phosphor-icons/react';
import { Transaction } from 'models/Transaction';
import TransactionCard from '../Card/TransactionCard';

interface QuickViewTransactionsModalProps {
  isOpen: boolean;
  onClose: () => void;
  transactions: Transaction[];
  customButton?: React.ReactNode;
  title?: string;
  subtitle?: string;
}

const QuickViewTransactionsModal: React.FC<QuickViewTransactionsModalProps> = ({
  isOpen,
  onClose,
  transactions,
  customButton,
  title = 'DANH SÁCH GIAO DỊCH',
  subtitle = 'Tất cả các giao dịch liên quan đều được hiển thị tại đây',
}) => {
  const handleTransactionClick = (transaction: Transaction) => {
    // Handle transaction detail view
    console.log('View transaction detail:', transaction.id);
  };

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      width={1400}
      className='modal-none-padding'
      closeIcon={<X size={28} color='var(--textBlack)' />}
      maskClosable={false}
      centered
      destroyOnClose={true}
    >
      <div className='bg-white rounded-lg'>
        <div className='px-6 py-3'>
          <h2 className='text-2xl font-bold'>{title}</h2>
          <p className='text-[var(--textGray)] text-sm mt-2'>{subtitle}</p>
        </div>

        <div className='mt-2 rounded-b-lg overflow-hidden'>
          <div className='max-h-[80vh] overflow-y-auto'>
            <div className='flex flex-col bg-[var(--bgGreyColor)]'>
              {transactions && transactions.length > 0 ? (
                <div className='flex flex-col gap-2 p-4'>
                  {[...transactions]
                    .sort((a, b) => {
                      const dateA = a.createdAt ? new Date(a.createdAt).getTime() : 0;
                      const dateB = b.createdAt ? new Date(b.createdAt).getTime() : 0;
                      return dateB - dateA;
                    })
                    .map((transaction) => (
                      <TransactionCard
                        key={transaction.id}
                        transaction={transaction}
                        onClick={() => handleTransactionClick(transaction)}
                      />
                    ))}
                </div>
              ) : (
                <div className='flex flex-col items-center justify-center py-16'>
                  <div className='text-gray-400 text-lg mb-2'>Không có giao dịch nào</div>
                  <p className='text-gray-400 text-sm'>Chưa có giao dịch nào được thực hiện</p>
                </div>
              )}
            </div>
          </div>
        </div>

        {customButton && (
          <div className='bg-[var(--bgGreyColor)] rounded-b-lg flex justify-center items-center py-2 gap-2'>
            {customButton}
          </div>
        )}
      </div>
    </Modal>
  );
};

export default QuickViewTransactionsModal;
